class PricingSelect {
  constructor(pricingSelect) {
    this.pricingSelect = pricingSelect;
    this.detailsElement = pricingSelect.querySelector('[data-pricing-select-details]');
    this.summaryElement = pricingSelect.querySelector('[data-pricing-select-summary]');
    this.optionElements = pricingSelect.querySelectorAll('[data-pricing-select-option]');
    this.displayedValue = pricingSelect.querySelector('[data-pricing-select-price]');

    this.addListeners();
    this.initializeDefault();
  }

  initializeDefault() {
    const firstOption = this.optionElements[0];
    if (firstOption) {
      this.handleOptionClick(firstOption);
    }
  }

  addListeners() {
    this.optionElements.forEach(option => {
      option.addEventListener('click', () => this.handleOptionClick(option));
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          this.handleOptionClick(option);
        }
      });
    });

    if (this.detailsElement) {
      this.detailsElement.addEventListener('keydown', (e) => this.handleKeyboardNavigation(e));
    }

    document.addEventListener('click', (e) => this.checkClickOutside(e));
  }

  handleOptionClick(optionElement) {
    this.optionElements.forEach(option => {
      option.classList.remove('is-selected');
    });

    optionElement.classList.add('is-selected');

    const selectedLabel = optionElement.getAttribute('data-pricing-select-option-label');
    const selectedValue = optionElement.getAttribute('data-pricing-select-option');
    this.summaryElement.textContent = selectedLabel;
    this.displayedValue.textContent = selectedValue;

    if (this.detailsElement) {
      this.detailsElement.removeAttribute('open');
    }
  }

  handleKeyboardNavigation(e) {
    if (!this.detailsElement.hasAttribute('open')) return;
    const focusableElements = [this.summaryElement.parentElement, ...this.optionElements];
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.key === 'Escape') {
      this.detailsElement.removeAttribute('open');
    } else if (e.key === 'Tab') {
      this.tabFocus(e, firstElement, lastElement);
    }
  }

  tabFocus(e, firstElement, lastElement) {
    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    } else if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }
  }

  checkClickOutside(e) {
    if (!this.detailsElement.contains(e.target) && this.detailsElement.hasAttribute('open')) {
      this.detailsElement.removeAttribute('open');
    }
  }
}

document.querySelectorAll('[data-pricing-select]').forEach(element => {
	new PricingSelect(element);
});